import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-qc-bg text-qc-text">
      <div 
        className="px-5 py-3 flex items-center max-w-2xl mx-auto"
        style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top, 0px))' }}
      >
        <Link
          to="/login"
          data-testid="privacy-back-button"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-qc-surface border border-qc-border text-qc-text"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <h1 className="text-base font-extrabold text-qc-text ml-3">Privacy Policy</h1>
      </div>

      <div className="max-w-2xl mx-auto px-5 py-6" data-testid="privacy-page">
        <h1 className="text-3xl font-black text-qc-text mb-6">Privacy Policy</h1>
        
        <div className="prose prose-invert prose-sm max-w-none space-y-6 text-qc-text-dim">
          <p className="text-sm">
            <strong className="text-qc-text">Last updated:</strong> January 2025
          </p>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">1. Information We Collect</h2>
            <p>We collect information you provide directly, including:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Account information (email address, password)</li>
              <li>Health profile data (dietary goals, restrictions, allergies)</li>
              <li>Product images you scan</li>
              <li>Scan history and verdicts</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">2. How We Use Your Information</h2>
            <p>We use collected information to:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Provide personalized product verdicts based on your health profile</li>
              <li>Maintain your scan history</li>
              <li>Improve our AI analysis accuracy</li>
              <li>Send important service updates</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">3. Data Storage and Security</h2>
            <p>
              Your data is stored securely using industry-standard encryption. Product images are processed 
              for analysis and stored to maintain your scan history. We implement appropriate technical 
              and organizational measures to protect your personal information.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">4. Data Sharing</h2>
            <p>
              We do not sell your personal information. We may share data with service providers who assist 
              in operating our Service, subject to confidentiality agreements. We may disclose information 
              if required by law.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Access your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your account and data</li>
              <li>Export your scan history</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">6. Children&apos;s Privacy</h2>
            <p>
              Green Light is intended for users 13 years and older. Family profiles for children are managed 
              by parent accounts and do not involve direct collection of children&apos;s personal information.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">7. Cookies and Tracking</h2>
            <p>
              We use essential cookies to maintain your session and preferences. We do not use third-party 
              tracking cookies for advertising purposes.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. We will notify you of significant changes 
              via email or through the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">9. Contact Us</h2>
            <p>
              For privacy-related questions or to exercise your rights, please visit our <Link to="/contact" className="text-qc-green hover:text-qc-green-dark font-medium">Contact page</Link>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
